<template>
  <div class="coach-detail-show-page">
    <header-component></header-component>
    <div class="cdsp-content">
      <div class="header">
        <div v-if="personInfo.extra_info.avatar" class="img-person">
          <img :src="personInfo.extra_info.avatar" />
        </div>
        <div v-else class="img-person no-img">{{ personInfo.first_name[0] }}</div>
        <div class="button-box">
          <div v-if="!editflag" @click="editflag = true" class="leapin-primary-huge-button edit-but">
            <span><img :src="edit" /> Edit</span>
          </div>
          <div v-else @click="editflag = false" class="leapin-primary-huge-button edit-but">
            <span>Back</span>
          </div>
        </div>
      </div>
      <!-- 人员信息展示 -->
      <div v-if="!editflag" class="person-info-content">
        <!-- 基础信息 -->
        <div class="person-base-info">
          <div class="pic-title"> 
            <span class="name">{{ personInfo.first_name }}  {{ personInfo.last_name }}</span>
          </div>
          <div class="pic-info">
            <div class="info-item">
              <img :src="emailSvg" /> 
              <span>{{ personInfo.email }}</span>
            </div>
            <div class="info-item">
              <img :src="phoneSvg" />
              <span>
                {{ personInfo.mobile_country_code }} -
                {{ personInfo.mobile }}
              </span>
            </div>
            <div class="info-item" style="width: 40%;">
              <img :src="locationSvg" />
              <span>{{ getEmptyBack(personInfo.extra_info.location) }}</span>
            </div>
            <!-- <div class="info-item">
              <img :src="shipSvg" /> 
              <span> Executive (Leadership Development)</span>
            </div>
            <div class="info-item">
              <img :src="facebookSvg" /> 
              <span>{{ getEmptyBack(personInfo.extra_info.linkedin) }}</span>
            </div> -->
          </div>

          <!-- <div class="pic-info">
            <div class="info-item">
              <img :src="phoneSvg" />
              <span>{{ getEmptyBack(personInfo.mobile) }}</span>
            </div>
            <div class="info-item">
              <img :src="earthSvg" />
              <span>{{ getEmptyBack(personInfo.extra_info.personal_website) }}</span>
            </div>
            <div class="info-item">
              <img :src="insSvg" /> 
              <span>{{ getEmptyBack(personInfo.extra_info.linkedin) }}</span>
            </div>
          </div>

          <div class="pic-info">
            <div class="info-item">
              <img :src="locationSvg" />
              <span>{{ getEmptyBack(personInfo.extra_info.intention_address.join('/')) }}</span>
            </div>
            <div class="info-item">
            </div>
            <div class="info-item">
              <img :src="xSvg" />
              <span>{{ getEmptyBack(personInfo.extra_info.twitter) }}</span>
            </div>
          </div> -->
        </div>
        <!-- candidate信息展示 -->
        <div class="summary-info">
          <div class="si-left">
            <!-- 内容项展示-start -->
            <div class="info-item" v-for="(item,index) in infoItemList" :key="index">
              <div class="leapin-air-title">
                <img :src="linkAir" />{{ item.title }}</div>
              <div class="content" v-if="item.type == 'list'">
                <div class="leapin-tags leapin-purple">
                  {{ getListValueBack(item.value,item.list) }}
                </div>
              </div>
              <div class="content" v-else-if="item.type == 'enterList'">
                <div class="leapin-tags leapin-purple" v-for="(child,i) in item.value" :key="i">
                  <span v-if="item.field == 'job_type'">
                      {{ getListValueBack(child,item.list) }}
                  </span>
                  <span v-if="item.field == 'intention_address'">
                      {{ child.join('/') }}
                  </span>
                  <span v-if="item.field != 'job_type' && item.field != 'intention_address'">{{ child }}</span>
                </div>
              </div>
              <div class="content" v-else>
                {{ getEmptyBack(item.value) }}
              </div>
            </div>
            <!-- 内容项展示-end -->

            <!-- cv展示 -->
<!--            <div class="cv-info">-->
<!--              <div class="leapin-air-title"><img :src="linkAir" />Your cv</div>-->
<!--              <div class="cv-item-list">-->
<!--                <div class="cv-item">-->
<!--                  <img :src="cvSvg" />-->
<!--                  <span>CV-{{ personInfo.extra_info.cv_url }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>

          <!-- 视频展示 -->
          <div class="si-right">
            <div class="item-title">
              <img :src="linkAir" /> Video
            </div>
            <video
              controls
              class="video-box"
              :src="personInfo.extra_info.introduce_video_url">
              </video>
          </div>
        </div>
      </div>
      <!-- 信息修改填写 -->
      <info-form v-else :editType="1" @updateInfo="updateInfo" @scrollToTop="scrollToTop"></info-form>
    </div>

  </div>
</template>

<script>
import { getUserInfo } from '@/services/user';
import { join } from 'lodash';
export default {
  components: {
    HeaderComponent: () => import('@/components/header/Header.vue'),
    InfoForm: () => import('./components/infoForm.vue')
  },
  name: 'CoachShow',
  data() {
    return {
      editflag: false,
      infoItemList: [
        // {
        //   title: 'What are you doing currently?',
        //   list: [
        //     { label: 'College student', value: 0 },
        //     { label: 'Working professional ', value: 1 },
        //     { label: 'Sabbatical or Carrer break ', value: 2 },
        //   ],
        //   value: '',
        //   field: 'current_career',
        //   type: 'list',
        // },
        // {
        //   title: "What's your career objective?",
        //   list: [
        //     { label: 'Secure a new job', value: 0 },
        //     { label: 'Learn a new skills ', value: 1 },
        //     { label: 'Gain industry experience', value: 2 },
        //     { label: 'Growth in the currrent job ', value: 3 },
        //     { label: 'Job transition', value: 4 }
        //   ],
        //   value: 0,
        //   field: 'career_objective',
        //   type: 'list',
        // },
        {
          title: "First name",
          value: '',
          type: 'enter',
          field: 'first_name',
        },
        {
          title: "Last name",
          value: '',
          type: 'enter',
          field: 'last_name',
        },
        // {
        //   title: "What kind of job are you looking for?",
        //   value: [],
        //   type: 'enterList',
        //   field: 'intention_job_list',
        // },
        // {
        //   title: "Job type",
        //   list: [
        //     { label: 'Full-time', value: 0 },
        //     { label: 'Part-time', value: 1 },
        //     { label: 'Internship', value: 2 },
        //     { label: 'Contract', value: 3 },
        //     { label: 'Freelance', value: 4 },
        //     { label: 'Other', value: 5 }
        //   ],
        //   type: 'enterList',
        //   value: '',
        //   field: 'job_type',
        // },
        {
          title: "Intention address",
          value: [],
          type: 'enterList',
          field: 'intention_address',
        },
        // {
        //   title: "Your ideal company stage?",
        //   list: [
        //     { label: 'EarlyStage', value: 0 },
        //     { label: 'GrowthStage', value: 1 },
        //     { label: 'LateStage', value: 2 },
        //     { label: 'PublicCompany', value: 3 },
        //   ],
        //   type: 'list',
        //   value: '',
        //   field: 'company_stage',
        // },
        {
          title: "Do you have your career goals? What do you hope to achieve in the next 3-5years?",
          value: '',
          type: 'enter',
          field: 'career_plan',
        },
        {
          title: "What's your challenges right now?",
          value: '',
          type: 'enterList',
          field: 'challenges',
        },
        {
          title: "Share with us your LinkedIn profile.",
          value: '',
          type: 'enter',
          field: 'personal_website',
        },
        {
          title: "Please describe your interests, hobbies, and strengths in one sentence.",
          value: '',
          type: 'enter',
          field: 'hobbies',
        },
      ],
      videoSrc: '',
      languagesList: [
        'English',
        'Finnish',
        'Swedish',
        'German',
        'French',
        'Spanish',
      ],
      cvSvg: require('@/assets/svgs/cv.svg'),
      edit: require('@/assets/svgs/edit.svg'),
      linkAir: require('@/assets/svgs/link-air.svg'),
      locationSvg: require('@/assets/svgs/location.svg'),
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      star: require('@/assets/svgs/star.svg'),
      coachDetailBg1: require('@/assets/images/coach/coach-detail-bg1.png'),
      peopleImg: require('@/assets/images/users/candidate6.png'),
      earthSvg: require('@/assets/svgs/coach/earth.svg'),
      emailSvg: require('@/assets/svgs/coach/email.svg'),
      facebookSvg: require('@/assets/svgs/coach/facebook.svg'),
      insSvg: require('@/assets/svgs/coach/ins.svg'),
      phoneSvg: require('@/assets/svgs/coach/phone.svg'),
      shipSvg: require('@/assets/svgs/coach/ship.svg'),
      xSvg: require('@/assets/svgs/coach/x.svg'),
      personInfo: {
        first_name: '',
        extra_info: {},
      }, // 人员信息
    }
  },
  mounted () {
    this.getReportInfo();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    // 完成修改
    updateInfo() {
      this.editflag = false;
      this.getReportInfo();
    },
    //获取登陆人信息
    getReportInfo() {
      getUserInfo({}).then((res) => {
        this.$store.dispatch("user:userinfo", res.data);
        if (res.code === 0) {
          this.personInfo = res.data;
          this.infoItemList.forEach((e) => {
            if (e.field == 'first_name' || e.field == 'last_name') {
              e.value = this.personInfo[e.field];
            } else {
              e.value = this.personInfo.extra_info[e.field];
            }
          });
          //console.log(this.personInfo);
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 获取列表Lael返回
    getListValueBack(value, list) {
      let result = '';
      list.forEach((e) => {
        if (e.value == value) {
          result = e.label;
        }
      });
      return result;
    },
  }
}
</script>
<style scoped lang="scss">
.coach-detail-show-page {
  background: url('../../assets/images/users/candidate-detail-bg1.png') no-repeat;
  background-position: top center;
  width: 100%;
  .cdsp-content {
    margin: 0 152px;
    position: relative;
    top: 105px;
    .header {
      height: 190px;
      position: relative;
      .img-person {
        position: absolute;
        width: 130px;
        height: 130px;
        object-fit: cover;
        bottom: 15px;
        left: 34px;
        border-radius: 100px;
        padding: 4px;
        background: #fff;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 100px;
        }
      }
      .no-img {
        background: #6E62E5;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 50px;
      }
      .button-box {
        position: absolute;
        bottom: 0;
        right: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0 10px;
        .edit-but {
          padding: 6px 50px !important;
        }
      }
    }
    .person-info-content {
      padding: 0 32px 70px 32px;
      font-family: "PingFang SC";
      .person-base-info {
        padding-bottom: 10px;
        border-bottom: 1px solid #E5E5E5;
        .pic-title {
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            color: #000;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 6px;
            letter-spacing: 0.5px;
          }
        }
        .pic-info {
          color: #000;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .info-item {
            display: flex;
            gap: 0 6px;
            align-items: center;
            justify-content: flex-start;
            width: 22%;
            margin-right: 32px;
          }
          span {
            color: #6E62E5;
          }
        }
      }
      .item-title {
        color: #000;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 14px;
        font-family: "PingFang SC";
        display: flex;
        align-items: center;
        justify-content: flex-start;
        letter-spacing: 0.5px;
        img {
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
      }
      .summary-info {
        display: flex;
        justify-content: space-between;
        gap: 0 24px;
        margin-top: 24px;
        .si-left {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          gap: 32px 0;
          .info-item {
            .content {
              margin-left: 25px;
              display: flex;
              gap: 6px;
              justify-content: flex-start;
              align-items: flex-start;
              font-size: 14px;
              color: #000;
              font-size: medium;
              padding-top: 8px;
            }
          }
          .cv-info {
            padding: 16px;
            border-radius: 12px;
            background: #F8F9FB;
            .cv-item-list {
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              gap: 10px;
              .cv-item {
                display: flex;
                width: fit-content;
                padding: 12px 16px;
                align-items: center;
                gap: 12px;
                border-radius: 100px;
                background: #FFF;
              }
            }
          }
        }
        .si-right {
          width: 384px;
          height: 100%;
          flex-grow: 0;
          border-radius: 12px;
          background: #F8F9FB;
          padding: 16px;
          .video-box {
            width: 384px;
            height: 254px;
            object-fit: cover;
          }
        }
      }


    }
  }
}
</style>
